
const ApplicationConfig = {
    BACKEND_URL : process.env.REACT_APP_API_URL,
    ENVIRONMENT : process.env.REACT_APP_ENVIRONMENT,
}

export default ApplicationConfig;